import { useState, useRef, useEffect, MouseEventHandler } from 'react';

import useSlider from 'js/hooks/use-slider';
import useIsScreenSize from 'js/hooks/use-is-screen-size';

interface IVolumeSlider {
  volume: number;
  setVolume: (volume: number) => void;
  close: () => void;
}

const VolumeSlider: React.FC<IVolumeSlider> = ({ volume, setVolume, close }) => {
  const [isCursorInside, setIsCursorInside] = useState(true);
  const [markerPosition, setMarkerPosition] = useState(0);

  const trackRef = useRef<HTMLDivElement>(null);

  const { value, activate, deactivate, isActive, activateKeys, deactivateKeys } = useSlider(trackRef, volume, true);

  const isMobile = useIsScreenSize('lg') === false;
  useEffect(() => {
    if (isMobile) {
      activate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile]);
  // activate is a callback from useSlider hook - adding causes re-renders

  useEffect(() => {
    const ratio = (trackRef.current?.offsetHeight || 0) / 1;
    const OffsetBottomPosition = volume * ratio;
    setMarkerPosition(OffsetBottomPosition);
  }, [volume]);

  useEffect(() => {
    if (!isActive && !isCursorInside) close();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActive, isCursorInside]);
  // close is a prop callback - adding causes re-renders

  useEffect(() => {
    if (value) {
      setVolume(value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  // setVolume is a prop callback - adding causes re-renders

  useEffect(() => {
    activateKeys();
    return () => deactivateKeys();
  }, [activateKeys, deactivateKeys]);

  return (
    <div
      className="volume-slider"
      onMouseDown={activate}
      onMouseUp={deactivate as unknown as MouseEventHandler<HTMLDivElement>}
      onMouseEnter={() => setIsCursorInside(true)}
      onMouseLeave={() => setIsCursorInside(false)}
    >
      <div className="volume-slider--track" ref={trackRef}>
        <span
          className="volume-slider--marker"
          style={{
            transform: `translate(-50%,calc(-${markerPosition}px + 50%))`
          }}
        />
      </div>
    </div>
  );
};

VolumeSlider.displayName = 'VolumeSlider';

export default VolumeSlider;
